export const routesClient = [
  {
    path: "/dugun/:uuid",
    name: "dugun",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/client/dugun/index.vue"),
  },
  {
    path: "/resimler/:uuid",
    name: "resimler",
    meta: { public: false },
    component: () => import("@/views/client/resimler/index.vue"),
  },
  {
    path: "/paket_alma",
    name: "paket_alma",
    meta: { public: false },
    component: () => import("@/views/client/paket_alma/index.vue"),
  },
];
